import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "relative inline-block",
  ref: "container"
}
const _hoisted_2 = { key: 2 }
const _hoisted_3 = ["aria-label"]
const _hoisted_4 = {
  key: 0,
  class: "absolute inset-0 -z-10 backdrop-blur-sm"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.effectiveTriggerType === 'hover')
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          onMouseenter: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showTooltip = true)),
          onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showTooltip = false)),
          onFocus: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showTooltip = true)),
          onBlur: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showTooltip = false)),
          class: "cursor-pointer"
        }, [
          _renderSlot(_ctx.$slots, "default")
        ], 32))
      : (_ctx.effectiveTriggerType === 'click')
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.toggleTooltip && _ctx.toggleTooltip(...args))),
            onTouchstart: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleTooltip && _ctx.toggleTooltip(...args)), ["prevent","stop"])),
            class: "cursor-pointer"
          }, [
            _renderSlot(_ctx.$slots, "default")
          ], 32))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _renderSlot(_ctx.$slots, "default")
          ])),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(_Transition, { name: "fade" }, {
        default: _withCtx(() => [
          (_ctx.showTooltip && _ctx.text)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                style: _normalizeStyle(_ctx.tooltipStyle),
                class: _normalizeClass([
                        'pointer-events-none fixed z-[9999] flex h-[37px] items-center whitespace-nowrap border border-solid border-gray-400 bg-white text-gray-400',
                        _ctx.baseClasses
                    ]),
                role: "tooltip",
                "aria-label": _ctx.text
              }, [
                (_ctx.backdropBlur)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4))
                  : _createCommentVNode("", true),
                _createTextVNode(" " + _toDisplayString(_ctx.text), 1),
                _createElementVNode("div", {
                  style: _normalizeStyle(_ctx.arrowWrapperStyle),
                  class: "absolute"
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.arrowClasses),
                    style: _normalizeStyle(_ctx.arrowStyle)
                  }, null, 6)
                ], 4)
              ], 14, _hoisted_3))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]))
  ], 512))
}